import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import CriarProcesso from "./registrarTipoProcesso";

export default function EditarProcesso() {
  const { id } = useParams();
  const navigate = useNavigate();

  const voltar = () => {
    navigate("/admin/processo", {
      replace: true,
    });
  };

  return (
    <CriarProcesso
      modo="editar"
      processoId={id}
      onCancelar={voltar}
      onAtualizado={voltar}
    />
  );
}
